import _ from 'lodash'
import { getDmakerTemplateOriginalInfo } from '@/api/creative/template'
import { getDmakerProjectOriginalInfo } from '@pt/api/gmaker/project.js'
import { getGmakerTemplateOriginalInfo } from '@/api/gmaker/template.js'
import { getDmakerCustomOriginalInfo } from '@/api/dmaker/custom.js'
import { cookGameConfig } from '../common/game-config'

const cookApiParams = ({ page, id, skinId, templateType }) => {
  const getProjectOriginalInfo = () => {
    return {
      params: {
        template_id: id,
        skin_id: skinId,
      },
      request: getDmakerProjectOriginalInfo,
    }
  }
  const commonTemplateCustomApiUtils = {
    'common-template-dco': getProjectOriginalInfo,
    'common-template-custom': getProjectOriginalInfo,
    'common-template-multi-custom': getProjectOriginalInfo,
  }

  const templateApiUtils = {
    template: () => {
      if (templateType === 'gm') {
        return {
          params: {
            id,
            type: 1, // 基础包配置
          },
          request: getGmakerTemplateOriginalInfo,
        }
      }
      return {
        params: {
          id,
          type: 1, // 基础包配置
        },
        request: getDmakerTemplateOriginalInfo,
      }
    },

    'common-template': () => {
      return {
        params: {
          id,
          skin_id: skinId,
          type: 1, // 基础包配置
        },
        request: getGmakerTemplateOriginalInfo,
      }
    },
  }

  const getDmakerCustomInfo = () => {
    return {
      params: {
        template_id: id,
      },
      request: getDmakerCustomOriginalInfo,
    }
  }
  const templateCustomApiUtils = {
    custom: getDmakerCustomInfo,
    dco: getDmakerCustomInfo,
    'multi-custom': getDmakerCustomInfo,
  }

  const apiUtils = {
    ...templateApiUtils,
    ...templateCustomApiUtils,
    ...commonTemplateCustomApiUtils,
  }

  return (
    apiUtils[page]() || {
      params: {
        id,
        type: 2, // 模板配置
      },
      request: getDmakerTemplateOriginalInfo,
    }
  )
}

export default async function ({ state, commit }) {
  const apiParams = cookApiParams({
    page: state.page,
    id: state.templateId,
    skinId: state.skinId,
    templateType: state.templateType,
  })
  const res = await apiParams.request(apiParams.params)

  if (_.get(res, 'data.code') === 0) {
    try {
      let jsonConfig = _.get(res, 'data.data.init_json_config') || null
      const resources = _.get(res, 'data.data.resources') || null
      jsonConfig = _.isString(jsonConfig) ? JSON.parse(jsonConfig) : jsonConfig
      if (!_.isEmpty(jsonConfig.gameConfig)) {
        jsonConfig.gameConfig = cookGameConfig(jsonConfig.gameConfig)
      }
      commit('updateOriginalJson', jsonConfig)
      commit('updateOriginalResources', resources)
    } catch (e) {
      commit('updateOriginalJson', null)
      commit('updateOriginalResources', null)
      console.warn('getDmakerTemplateOriginalInfo 发生错误')
      console.log(_.get(res, 'data.data'))
    }
  }
}
